export const logOut = async (siteType: string) => {
    const response = await fetch('/logout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            siteType,
        }),
    });

    if (response.ok) {
        // Ensures no client-side state is left (e.g. showpad certificates)
        window.location.reload();
    }
};
